<template>
  <div>
    <Breadcrumb :title="'Information Tracker'"></Breadcrumb>
    <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar :config="toolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    <BaseGrid
      :excelExport="excelExport"
      :colorizeColumn="true"
      :config="GridConfig"
      :mode="'editform'"
      @EditItem="EditInfoTracker"
      @AttachItem="InformationTrackingAttachment"
    ></BaseGrid>
    <InfoTrackerForm
      :ref="'refInfoTrackerForm'"
      :InfoTrackerFormConfig="InfoTrackerJSON"
      :partnerAutoCompleteDisplayedValue="partnerAutoCompleteDisplayedValue"
      :programAutoCompleteDisplayedValue="programAutoCompleteDisplayedValue"
      :InfoTrackerModalLabel="modalConfig"
      @SaveComplete="refreshGrid"
    ></InfoTrackerForm>
    <InfoTrackerDocumentDropoffForm
      ref="infoTrackingDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedInformationTracking"
      @SaveComplete="refreshGrid"
    ></InfoTrackerDocumentDropoffForm>
  </div>
</template>

<script>
import $ from "jquery";
import {
  GridConfig,
  InfoTrackerToolbarConfig,
  InfoTrackerUpdateConfig
} from "./InfoTrackerConfig.js";
import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";

import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";

import BaseSearchBar from "@/components/base/BaseSearchBar.vue";

import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";

import { mapGetters, mapActions, mapState } from "vuex";

import InfoTrackerDocumentDropoffForm from "@/components/forms/InfoTrackerDocumentDropoffForm.vue";
import InfoTrackerForm from "@/components/forms/InfoTrackerForm.vue";

export default {
  name: "InformationTracker",
  mixins: [apiUtil, funcUtil, toolbarUtility],

  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    InfoTrackerForm,
    InfoTrackerDocumentDropoffForm
  },

  computed: {
    ...mapGetters("getModule", ["withFilter"]),
    ...mapState("postModule", ["response"])
  },

  data: function() {
    return {
      GridConfig: GridConfig,
      InfoTrackerGridId: GridConfig.grid.gridId,
      toolbarConfig: InfoTrackerToolbarConfig,

      search: {
        SearchData: ""
      },

      InfoTrackerMasterData: {},
      BaseModelInformationTracking: BaseModelInformationTracking,

      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },

      // Document dropoff modal
      docModalConfig: {
        modalName: "Information Tracking Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedInformationTracking: {},
      // customDocumentType:[{Option:"83(b)"},{Option:"Scans"},{Option:"Signature Page"}],
      InforTrackerGridData: [],
      InfoTrackerJSON: {},

      InfoTrackerDataJSON: {
        Id: "",
        PartnerId: "",
        ProgramId: "",
        PartnerTitle: "",
        ProgramTitle: "",
        SignaturePage: "",
        Receive83b: "",
        Receive83bFiledWithIRS: "",
        AmountOwed: "",
        Payment: "",
        MethodofPayment: "",
        CheckNumber: "",
        DateDeposited: "",
        DateWired: ""
      },
      partnerAutoCompleteDisplayedValue: {
        displayedValue: ""
      },
      programAutoCompleteDisplayedValue: {
        displayedValue: ""
      }
    };
  },
  mounted() {
    const self = this;
    console.log(self.grid);

    //bind databound event to grid
    var grid = $("#InformationTrackingGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateDistributionMasterData);
    grid.dataSource.fetch();
    //changes for Toolbar
    self._loadGridSettings(self.InfoTrackerGridId);

    //self.getInfoTrackerData();
  },

  methods: {
    ...mapActions("postModule", ["DeleteItem", "UpdateAllItems"]),

    UpdateDistributionMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.InfoTrackerMasterData = filterMasterData;
      } else {
        this.InfoTrackerMasterData = JSON.parse(
          JSON.stringify(
            $("#InformationTrackingGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
    },

    toolbarOnClick: function(e) {
      const self = this;
      e.preventDefault();
      switch (e.id) {
        case "btnCalculate":
          self.Calculate();
          break;
        case "btnAddInfoTracker":
          this.AddInfoTracker();
          window.$("#BaseModal").modal("toggle");
          break;
        case "btnBulkImportIssuance":
          this.$router.push("/admin/tracker/upload");
          break;
      }
      this._baseToolBarEvents("InformationTrackingGrid", ...arguments);
    },

    refreshGrid: function() {
      // console.log("refresh grid Distribution");
      //this.getInfoTrackerData();
      $("#" + this.InfoTrackerGridId)
        .data()
        .kendoGrid.dataSource.read();
    },

    filterGrid: function() {
      let self = this;
      var currentMasterdata = this.InfoTrackerMasterData;
      let filteredData = this._filterGrid(
        this.InfoTrackerMasterData,
        this.search.SearchData
      );
      $("#InformationTrackingGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateDistributionMasterData(true, currentMasterdata);
    },

    AddInfoTracker: function() {
      const self = this;
      self.modalConfig.modalName = "Add Information Tracker";
      self.modalConfig.modalAddorEdit = "Add";

      self.InfoTrackerDataJSON.Id = "";
      self.InfoTrackerDataJSON.PartnerTitle = "";
      self.InfoTrackerDataJSON.ProgramTitle = "";
      self.InfoTrackerDataJSON.SignaturePage = "";
      self.InfoTrackerDataJSON.Receive83b = "";
      self.InfoTrackerDataJSON.Receive83bFiledWithIRS = "";
      self.InfoTrackerDataJSON.AmountOwed = "";
      self.InfoTrackerDataJSON.Payment = "";
      self.InfoTrackerDataJSON.MethodofPayment = "";
      self.InfoTrackerDataJSON.CheckNumber = "";
      self.InfoTrackerDataJSON.DateDeposited = "";
      self.InfoTrackerDataJSON.DateWired = "";
      self.InfoTrackerDataJSON.LastCompleted = "";

      self.InfoTrackerJSON = self.InfoTrackerDataJSON;

      self.partnerAutoCompleteDisplayedValue.displayedValue = "";
      self.programAutoCompleteDisplayedValue.displayedValue = "";
    },

    EditInfoTracker: function(e) {
      let self = this;
      e.preventDefault();
      self.modalConfig.modalName = "Edit Information Tracker";
      self.modalConfig.modalAddorEdit = "Edit";
      var gview = window.$("#InformationTrackingGrid").data("kendoGrid");
      var dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      self.InfoTrackerDataJSON = { ...dataItem };

      self.InfoTrackerDataJSON.SignaturePage =
        self.InfoTrackerDataJSON.SignaturePage == "Received" ? true : false;
      self.InfoTrackerDataJSON.Receive83b =
        self.InfoTrackerDataJSON.Receive83b == "Received" ? true : false;
      self.InfoTrackerDataJSON.Receive83bFiledWithIRS =
        self.InfoTrackerDataJSON.Receive83bFiledWithIRS == "Received"
          ? true
          : false;

      self.InfoTrackerJSON = self.InfoTrackerDataJSON;

      self.partnerAutoCompleteDisplayedValue.displayedValue =
        self.InfoTrackerJSON.PartnerTitle;
      self.programAutoCompleteDisplayedValue.displayedValue =
        self.InfoTrackerJSON.ProgramTitle;

      self.$refs.refInfoTrackerForm.getInputControls();

      window.$("#BaseModal").modal("toggle");
    },

    getInfoTrackerData: function() {
      const self = this;
      let result = this.withFilter(self.GridConfig.list, "");
      self.InforTrackerGridData = result;
    },
    InformationTrackingAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#InformationTrackingGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedInformationTracking = { ...dataItem };

      (this.selectedInformationTracking.PartnerTitle =
        dataItem.PartnerFullName),
        (this.selectedInformationTracking.PartnerId = dataItem.PartnerId);
      this.selectedInformationTracking.TransactionID = dataItem.Id;
      this.selectedInformationTracking.BusinessEvent = "Information Tracking";

      this.filterCondition.filter = `BusinessEvent eq 'Information Tracking' and TransactionID eq ${dataItem.Id}`;

      this.$refs.infoTrackingDocument.$refs.informationTrackingDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    async Calculate() {
      let self = this;
      let grid = $("#" + self.InfoTrackerGridId).data("kendoGrid");
      let selectedItem = [];
      grid.select().each(function() {
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        selectedDataItem.Status = "Processing";
        //push the dataItem into the array
        selectedItem.push(selectedDataItem);
      });
      if (selectedItem.length <= 0) {
        // alert("Please select atleast one item.");
        // this.$swal({ type: "info", text: "Please select atleast one item." });
        this._AlertPopup("Please select atleast one row.", "info");
      } else {
        const message = "Are you sure to process the record(s)?";
        let result = await this._ConfirmationPopup(message, "Confirm");
        if (result.value) {
          const calculateConfig = {
            InformationTracker: {
              config: InfoTrackerUpdateConfig,
              updateData: selectedItem,
              processInBatches: true
            }
          };
          this._APICrudPopup("APICrudpopup");
          try {
            let calculateResponse = await this.UpdateAllItems(calculateConfig);
            grid.dataSource.read();
            this._AlertPopup(
              "Submitted for Processing Successfully!",
              "success"
            );
          } catch (error) {
            this._AlertPopup("Some Error Occurred!", "info");
          }
        }
      }
    }
  }
};
</script>
